(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-capability-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b2b-capability-carousel')) {
    customElements.define('b2b-capability-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.cards = Array.from(this.querySelectorAll('[data-carousel-card]'));
        this.previousButton = this.parentElement.querySelector('[data-carousel-previous]');
        this.nextButton = this.parentElement.querySelector('[data-carousel-next]');
        this.currentLabel = this.parentElement.querySelector('[data-carousel-current]');
        this.currentIndex = 0;

        if (!this.track || this.cards.length < 2) return;

        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.handleScroll = () => {
          window.cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = window.requestAnimationFrame(() => this.updateCurrent());
        };
        this.pause = () => this.stopAutoplay();
        this.resume = () => this.startAutoplay();

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.addEventListener('pointerenter', this.pause);
        this.addEventListener('pointerleave', this.resume);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.resume);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.removeEventListener('pointerenter', this.pause);
        this.removeEventListener('pointerleave', this.resume);
        this.removeEventListener('focusin', this.pause);
        this.removeEventListener('focusout', this.resume);
      }

      move(direction) {
        const nextIndex = (this.currentIndex + direction + this.cards.length) % this.cards.length;
        const card = this.cards[nextIndex];
        const trackRect = this.track.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const targetLeft = this.track.scrollLeft + cardRect.left - trackRect.left;

        this.track.scrollTo({
          left: targetLeft,
          behavior: 'smooth'
        });
        this.currentIndex = nextIndex;
        this.renderCurrent();
      }

      updateCurrent() {
        const trackLeft = this.track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.currentIndex = closestIndex;
        this.renderCurrent();
      }

      renderCurrent() {
        if (this.currentLabel) this.currentLabel.textContent = String(this.currentIndex + 1);
      }

      startAutoplay() {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay !== 'true' || reduceMotion || this.autoplayTimer) return;
        const speed = Number(this.dataset.speed) || 5000;
        this.autoplayTimer = window.setInterval(() => this.move(1), speed);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
